<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="detail">
              <HeaderBar title="详细消息"></HeaderBar>
              <div class="detail__card">
                <div class="detail__card__title">{{ title }}</div>
                <div class="ql-editor" style="width: 100%;" v-html="content"></div>
                <div class="attachment">
                  <div v-for="(file, index) in files" :key="index">
                    <el-link
                      :href="file.fileUrl"
                      target="_blank"
                      type="primary"
                    >
                      附件{{index+1}}: {{ file.fileOriginName }}
                    </el-link>
                    <br/>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import * as dayjs from 'dayjs';
import HeaderBar from '@/components/HeaderBar.vue';
import { prefixedUrlAsset } from '@/utils/constants';

// eslint-disable-next-line no-unused-vars
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: 'NewsDetail',
  data() {
    return {
      content: '',
      createDate: '',
      files: [],
      title: ''
    };
  },
  components: { HeaderBar },
  created() {
    console.log(this.$route.params.id);
    this.axios
      .get(`${prefixedUrlAsset}/pub/news/info/${this.$route.params.id}`)
      .then((response) => {
        console.log(response.data);
        this.createDate = dayjs(response.data.data.createDate).format('YYYY-MM-DD');
        this.content = response.data.data.content;
        this.title = response.data.data.title;
        this.files = response.data.data.files;
        console.log(this.content);
      });
  },
};
</script>

<style-scope lang="scss">
.detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  padding: 10px 10px 0px 10px;
  margin-bottom: 20px;
  &__card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
    &__title {
      background-color: white;
      width: 100%;
      line-height: 100px;
      color: black;
      font-size: 25px;
      font-weight: bold;
      align-self: center;
      text-align: center;
    }
  }
}
.attachment {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style-scope>
